import React from "react";
import Navbar from '../Auth/Navbar';

function TermsCondition() {
    return (
        <React.Fragment>
            <Navbar />
            <h1 style={{textAlign: 'center'}}>Terms & Conditions</h1>
        </React.Fragment>
    );
}

export default TermsCondition;